<template>
  <!-- <card :header-text="'Indices '"> -->
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
          </div>
        </div>
        <div class="col-md-6">
        </div>
        <div class="col-md-3">
          <goback></goback>
        </div>
      </div>
      <vue-tabs direction="horizontal" @tab-change="getTabData">
        <v-tab title="Indices">
          <div class="row mb5"></div>
          <div class="row mb5" v-if="latestData && latestData.date">
            <div class="col-md-5 form-group">
              <span>
                <strong>Date:</strong>
              </span>
              {{getDate(latestData.date)}}
            </div>
            </div>
          <div class="table-responsive" v-dragscroll="true">
            <table class="table table-bordered" style="font-size: 11px;" v-if="tableFields.length>0">
              <div v-for="(field, index, key) in tableFields" v-bind:key="'field'+field+index+key">
                <thead>
                  <tr>
                    <th
                      style="font-size:.92em; width: 10%;"
                      class="data-cell"
                      v-for="(fld, ind, k) in field"
                      v-bind:key="'fld'+fld+ind+k"
                    >{{fld.name}}</th>
                  </tr>
                </thead>
                <tbody v-if="typeof field === 'object'">
                  <tr v-for="(tr,trInd) in tableRows" v-bind:key="'row'+tr+trInd">
                    <td>{{tr.title}}</td>
                    <td>
                      <span v-if="latestData[tableFields[index][0].title]"> 
                        {{getFixed(latestData[tableFields[index][0].title][tr.title])}}
                      </span>
                      <span v-else>-</span>
                    </td>
                    <td v-for="(fld, ind, k) in field" v-bind:key="'fld1'+fld+ind+k" v-if="ind>1">
                      <span v-if="field.length>0">{{getFixed(rawData[field[0].title][trInd][tr.title][fld.title])}}</span>
                      <span v-else></span>
                    </td>
                  </tr>
                </tbody>
                <br>
                <br>
              </div>
            </table>
          </div>
        </v-tab>
        <v-tab title="Indices Graph">
          <IndicesChart/>
        </v-tab>
        <v-tab title="Latest Indices">
          <div class="row mb5"></div>
          <div class="row mb5" v-if="marketData.length>0">
            <div class="col-md-5 form-group">
              <span>
                <strong>Prev Date:</strong>
              </span>
              {{getFormattedDatewithTime(marketData[0].PrevDate)}}
            </div>
            <div class="col-md-5 form-group">
              <span>
                <strong>Update Date:</strong>
              </span>
              {{getFormattedDatewithTime(marketData[0].upd_time)}}
            </div>
            <div class="col-md-2">
              <download :tableId="'latest-indices'" :fileName="'latest-indices'"></download>
            </div>
          </div>
          <div class="table-responsive" v-dragscroll="true" v-if="marketData.length>0">
            <table id="latest-indices" class="table table-bordered fonts11">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Value</th>
                  <th>PE</th>
                  <th>PB</th>
                  <th>Div Yield</th>
                  <th>Earnings</th>
                  <th>Earnings Yield</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(sr, index) in marketData" v-bind:key="sr.co_code+index+sr.companyname">
                  <td>{{sr.aliasname}}</td>
                  <td>{{sr.Last}}</td>
                  <td>{{(sr.myData.length>0)? sr.myData[0].PE: '-'}}</td>
                  <td>{{(sr.myData.length>0)? sr.myData[0].BV: '-'}}</td>
                  <td>{{(sr.myData.length>0)? sr.myData[0].DivYearield: '-'}}</td>
                  <td>{{getFixed(sr.earnings)}}</td>
                  <td>{{getFixed(sr.earnings_yield)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="alert alert-danger" role="alert" v-else>No data found!</div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import http from "@/lib/http";
import IndicesChart from "./IndicesChart.vue";
import GroupVsComp from "./groupVsComp.vue";
import { commonMixins } from "@/assets/mixins/common.js";
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.scss'
export default {
  mounted() {},
  components: { IndicesChart, GroupVsComp, VueTabs, VTab },
  props: ["company"],
  mixins: [commonMixins],
  created() {
    console.log(this.rawDataList);
    // console.log("LLLLL",this.getDataInRatio());
    this.getRawData();
    // this.getChartData();
  },
  data() {
    return {
      rawDataType: 0,
      tableFields: [],
      tableRows: [],
      rawDataList: [],
      rawDataApi: "getIndicesData",
      rawData: [],
      searchData: [],
      searchText: "",
      selectedVal: "",
      index_code: 20559,
      chart_type: "index",
      chartIndicesData: [],
      downloadData: [],
      latestData: [],
      marketData: [],
      selChart: "",
      chartIndexData: {},
    };
  },
  methods: {
    getRawData() {
      this.isLoading = true;
      this.rawData = {};
      let myself = this;
      http.get(this.rawDataApi, {}, (error, response) => {
        console.log("RawData", response);
        console.log(this.tableFields);
        myself.rawData = response[0].values[0];
        myself.latestData = response[0].latest;
        var tableField = [];
        var i = 0;
        for (let cl in myself.rawData) {
          if (cl !== "_id") {
            var tableRows = [];
            i = i + 1;
            tableField[i] = [];
            tableField[i].push({
              title: cl,
              name: this.getLabel(cl).toUpperCase(),
              sort_order: 999999,
              isNumeric: true
            });
            tableField[i].push({
              title: "latest",
              name: "Latest",
              sort_order: 999998,
              isNumeric: true
            });
            for (let tf in myself.rawData[cl]) {
              tableRows.push({
                title: Object.keys(myself.rawData[cl][tf])[0],
                name: Object.keys(myself.rawData[cl][tf])[0],
                sort_order: Object.keys(myself.rawData[cl][tf])[0],
                isNumeric: true
              });
              if (
                typeof myself.rawData[cl][tf] === "object" &&
                Object.keys(myself.rawData[cl][tf])[0] === "Indices"
              ) {
                var tablColumns = Object.keys(
                  myself.rawData[cl][tf][Object.keys(myself.rawData[cl][tf])[0]]
                );
                for (let tblClm in tablColumns) {
                  // console.log("tblClm", tablColumns[tblClm]);
                  tableField[i].push({
                    title: tablColumns[tblClm],
                    name: this.getYearFromQuarterString(tablColumns[tblClm]),
                    sort_order: tablColumns[tblClm],
                    isNumeric: true
                  });
                }
              }
            }
            tableField[i] = myself.sorted_fields_desc(
              tableField[i],
              "sort_order"
            );
          }
        }
        myself.tableFields = myself.sorted_fields_desc(
          tableField,
          "sort_order"
        );
        myself.tableRows = tableRows;
        myself.searchData = response.final_data;
        console.log(myself.tableFields);
        console.log(myself.tableRows);
      });
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab);
      if (tabIndex == 0) {
        // this.rawDataApi = "getIndicesData";
        this.getRawData();
      } else if (tabIndex == 1) {
        // this.getChartData();
      } else if (tabIndex == 2) {
        this.getMarketData();
      } else if (tabIndex == 3) {
        // this.getIndicesMaster();
      }
    },
    getMarketData() {
      let url = "getAllMarketData";
      http.get(url, {}, (error, response) => {
        if (error === null) {
          if (response.length > 0) {
            this.marketData = response;
            this.marketData = this.marketData.reverse();
          }
        } else {
          console.log("error => ", error);
        }
      });
    },
    getPricevscomp() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        console.log("getIndustries Data", response);
        _this.companyList = response;
        if (_this.companyList.length > 0) {
          _this.selComp = _this.companyList[0];
          // _this.getCompPriceData();
          _this.getGroupData();
        }
      });
    },
    // getChartData() {
    //   http.get("getIndustryRatiosForChart", {}, (error, response) => {
    //     console.log("chartdata", response);
    // this.chartIndicesData = response;
    // console.log("sel chart", Object.keys(this.chartIndicesData)[0]);
    // this.selChart = Object.keys(this.chartIndicesData)[0];
    // this.chartIndexData = this.chartIndicesData[this.selChart];
    // this.setChartData();
    // let indexComps = Object.keys(this.chartIndicesData);
    // indexComps.forEach((val, key) => {
    //   this.priceVsIndexList.push({
    //     id: val,
    //     value: this.getLabel(val)
    //   });
    // });
    // console.log("BSE GROUPS", this.priceVsIndexList);
    //   });
    // },
  },
  mounted() {},
  watch: {
    data: function() {
      this._chart.destroy();
      // this.configureChart();
    }
  },
  computed: {
    getFields(field) {
      var fields = [];
      console.log("Fields", field);
      // field.forEach((fd, key) => {
      //   console.log(fd, key);
      // });
      return field;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table th.column-sort {
  cursor: pointer;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/indices-data/companywise-indices.vue